class OfficeTaystForm {
  constructor() {
    this.init();
  }
  init() {
    this.getCountryList();
    this.formEvents(this);
  }
  getCountryList(){
    fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vTcDgox_KaOhMJSbdGbXzVT7z8tT0EcnP22g-Iq1js1ydAcpqiVuapYuwP1Bz4XbHrm4C77VhfUNlAk/pub?gid=0&single=true&output=csv")
    .then(response => response.text())
    .then(response => {
      const countryList = document.getElementById("country_list");
      const stateList = document.getElementById("state_list");
      const lines = response.split("\n");
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;
        const values = line.split(",");
        if (!cn(values[0])) {
          const countryOpt = document.createElement("option");
          countryOpt.value = values[0];
          countryOpt.dataset.iso = values[1];
          countryOpt.dataset.code = values[2];
          countryOpt.dataset.phone = values[3];
          countryOpt.textContent = values[0];
          if (i == 1) countryOpt.selected = true;
          countryList.appendChild(countryOpt);
        }
        for (let j = 4; j < values.length; j++) {
          const stateVal = values[j].replaceAll('"', "").trim();
          if (!cn(stateVal)) {
            const stateOpt = document.createElement("option");
            stateOpt.value = stateVal;
            stateOpt.dataset.iso = values[1];
            stateOpt.textContent = stateVal;
            if (i != 1) {
              stateOpt.classList.add("hidden");
            }
            stateList.appendChild(stateOpt);
          }
        }
      }
    })
    .catch(() => {
      alert("Something went wrong. Try after sometime or contact us.");
    });
  }
  formEvents(that){
    document.addEventListener("click", function(e) {
      if(e.target.matches(".ottf-step-btn")){
        const isPrev = e.target.classList.contains("offt-prev");
        const currPar = e.target.closest(".office-tayst-test-form-step");
        const currentStep = currPar.getAttribute("data-step");
        let upcomingStep = parseInt(currentStep) + 1;
        if (isPrev) {
          upcomingStep = parseInt(currentStep) - 1;
        } else {
          const fields = currPar.querySelectorAll(".office-tayst-field");
          for (let i = 0; i < fields.length; i++) {
            const currInput = fields[i];
            const inputName = currInput.name;
            if (!currInput.checkValidity()) {
              currInput.reportValidity();
              return false;
            }
            if (inputName == "phone") {
              const phoneVal = currInput.value;
              if (phoneVal.length != 10) {
                const errSpan = currInput.parentElement.querySelector(".office-form-phone-err");
                errSpan.classList.remove("hidden");
                currInput.focus();
                setTimeout(() => {
                  errSpan.classList.add("hidden");
                }, 4000);
                return false;
              }
            }
          }
        }
        currPar.classList.add("hidden");
        const nextStep = document.querySelector(`.office-tayst-test-form-step[data-step="${upcomingStep}"]`);
        if (nextStep) {
          nextStep.classList.remove("hidden");
        }
        const wrap = document.querySelector(".ottf-wrap");
        if (wrap) {
          window.scrollTo({
            top: wrap.getBoundingClientRect().top + window.pageYOffset - 200,
            behavior: "smooth"
          });
        }
      }
    });
    document.addEventListener("change", function(e) {
      if(e.target.matches("#country_list")){
        const selectedOption = e.target.options[e.target.selectedIndex];
        const countryIso = selectedOption.getAttribute("data-iso");
        const stateList = document.getElementById("state_list");
        const allOptions = stateList.querySelectorAll("option");
        allOptions.forEach(opt => opt.classList.add("hidden"));
        stateList.value = "";
        const matchingOptions = stateList.querySelectorAll(`option[data-iso="${countryIso}"]`);
        matchingOptions.forEach(opt => opt.classList.remove("hidden"));
      }
    });
    document.getElementById("phone").addEventListener("input", function (e) {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    });
    document.addEventListener("submit", function(e) {
      if(e.target.matches("#office-tayst-test-form")){
        e.preventDefault();
        const btnForm = e.target;
        let checkboxValues = "";
        const hubspotUrl = tayst.hubspotContactBusiness;
        const machineCheck = btnForm.querySelectorAll(".ottf-machine-type[type=checkbox]:checked");
        if (machineCheck.length > 0) {
          for (let i = 0; i < machineCheck.length; i++) {
            const currCheck = machineCheck[i].value;
            if (i == machineCheck.length - 1) {
              checkboxValues += currCheck;
              break;
            }
            checkboxValues += currCheck + ", ";
          }
          const machineInput = btnForm.querySelector("input[name=type_of_machine]");
          if (machineInput) machineInput.value = checkboxValues;
          const queryString = window.location.search;
          if (queryString != "" && queryString.indexOf("utm_source") > -1) {
            const formUtmData = getUrlVars();
            btnForm.querySelector("[name=utm_source]").value = formUtmData.utm_source || "";
            btnForm.querySelector("[name=utm_medium]").value = formUtmData.utm_medium || "";
            btnForm.querySelector("[name=utm_campaign]").value = formUtmData.utm_campaign || "";
          }
          const formData = new URLSearchParams(new FormData(btnForm)).toString();
          const submitBtn = btnForm.querySelector("[type=submit]");
          submitBtn.disabled = true;
          submitBtn.classList.add("btn--loading");
          fetch(hubspotUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "data=" + encodeURIComponent(formData)
          })
          .then(res => res.text())
          .then(ret => {
            if (!cn(ret)) {
              ret = JSON.parse(ret);
              if (!cn(ret.vid)) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "OfficeTaystTestFormSubmit",
                  formElement: formData
                });
                btnForm.style.display = "none";
                const successBlock = document.querySelector(".office-tayst-form-success");
                if (successBlock) {
                  successBlock.style.display = "block";
                  window.scrollTo({
                    top: successBlock.getBoundingClientRect().top + window.pageYOffset - 200,
                    behavior: "smooth"
                  });
                }
              } else {
                alert(ret.message);
              }
            } else {
              alert("Something went wrong, please try after sometime");
            }
            submitBtn.disabled = false;
            submitBtn.classList.remove("btn--loading");
          });
        } else {
          const checkItem = btnForm.querySelector(".office-tayst-field[type=checkbox]:last-of-type");
          checkItem.setAttribute("required", true);
          if (!checkItem.checkValidity()) {
            setTimeout(function () {
              checkItem.removeAttribute("required");
            }, 1000);
            checkItem.reportValidity();
            return false;
          }
        }
      }
    });
  }
}
new OfficeTaystForm();